import React from 'react';
import { Box, Button } from '@mui/joy';

interface ModalActionsProps {
  onCancel: () => void;
  onApply: () => void;
}

const ModalActions: React.FC<ModalActionsProps> = ({ onCancel, onApply }) => {
  return (
    <Box display="flex" gap={2} mt={2}>
      <Button
        onClick={onCancel}
        size="md"
        fullWidth
        variant="soft"
        sx={{
          height: '52px',
          borderRadius: '12px',
          fontWeight: '600',
          fontSize: '16px',
          color: '#2E2D7E',
          bgcolor: '#F4F4F4'
        }}
      >
        Cancel
      </Button>
      <Button
        onClick={onApply}
        size="md"
        fullWidth
        sx={{
          height: '52px',
          borderRadius: '12px',
          backgroundColor: '#2e2d7e',
          color: '#fff',
          fontWeight: 500,
          fontSize: '16px',
          '&:hover': {
            backgroundColor: '#23225e',
          },
        }}
      >
        Apply
      </Button>
    </Box>
  );
};

export default ModalActions;
